import { useTranslation } from "react-i18next";
import { InteractiveMaterialResponseDto } from "@packages/api/madlenAPI.schemas";
import H5Test from "../../../../H5Test";
import { useEffect, useMemo } from "react";
import { getGetInteractiveMaterialQueryKey } from "@packages/api/madlenAPI";
import { useQueryClient } from "@tanstack/react-query";
import { Text } from "@core/index";
import { getEnvironment } from "@packages/utils";
interface ReviewTabProps {
  material: InteractiveMaterialResponseDto;
}

const ReviewTab = ({ material }: ReviewTabProps) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    console.log(material);
  }, [material]);

  const queryClient = useQueryClient();

  const contentJsonPath = useMemo(() => {
    if (!material.contentJsonS3Url) {
      queryClient.invalidateQueries({
        queryKey: getGetInteractiveMaterialQueryKey(Number(material.id)),
      });
      return "";
    }
    return (
      material.contentJsonS3Url +
      (i18n.language === "tr" ? "/tr" : "/en") +
      (getEnvironment() === "DEV" ? "/dev" : "")
    );
  }, [material, i18n.language]);

  if (!contentJsonPath || contentJsonPath === "") {
    return (
      <div className="h-[calc(100vh-20rem)] max-h-[800px] min-h-[600px] flex flex-col items-center justify-center space-y-4">
        <div className="w-16 h-16 border-4 border-rose-500 border-t-transparent rounded-full animate-spin"></div>
        <div className="text-center space-y-2">
          <Text variant={"h2"}>interactive_material.loadingVideo.title</Text>
          <Text variant="p" status="subtle" size={"base"}>
            interactive_material.loadingVideo.description
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-7rem)] max-h-[900px] min-h-[600px] flex flex-col items-center justify-center overflow-scroll">
      <div className="w-full mt-7 text-center">
        <Text className="font-semibold text-lg md:text-xl lg:text-2xl text-center text-rose-600 dark:text-rose-400">
          {t("interactive_material.review.studentViewPreview")}
        </Text>
      </div>
      <div className="w-full lg:w-[75%] h-full">
        <H5Test contentJsonPath={contentJsonPath} />
      </div>
    </div>
  );
};

export default ReviewTab;
